export const serverSolutionPricingItems: readonly [number[], number[]] = Object.freeze([
  [396000, 578000, 965000],
  [648000, 783000, 1310000],
]);
